<script>
import { ref, defineComponent } from "vue";
import { useTemplateRef } from "vue";
import { onClickOutside } from "@vueuse/core";
export default defineComponent({
  name: "RatingCriteriaPopup",
  props: {
    title: {
      type: String,
      required: true
    },
    image: {
      type: String,
      required: true
    },
    content: {
      type: Array,
      required: true
    }
  },
  setup() {
    const visible = ref(false);
    const popupContent = useTemplateRef("popupContent");
    const show = () => {
      visible.value = true;
      document.body.classList.add("overflow-hidden");
    };
    const hide = () => {
      visible.value = false;
      document.body.classList.remove("overflow-hidden");
    };
    const close = () => {
      hide();
    };
    onClickOutside(popupContent, () => {
      hide();
    });
    return {
      popupContent,
      visible,
      show,
      hide,
      close
    };
  },
  computed: {
    hasContentList() {
      return this.content?.length > 1;
    }
  }
});
</script>

<template>
    <div class="rating-criteria-popup_container" :class="{ hide: !visible }">
        <div ref="popupContent" class="rating-criteria-popup">
            <div class="rating-criteria-popup_image_container">
                <img :src="image" :alt="title" width="396" height="223" />
            </div>

            <div class="rating-criteria-popup_title_container">
                <div class="rating-criteria-popup_title">
                    {{ title }}
                </div>
                <ul
                    v-for="contentItem in content"
                    v-if="hasContentList"
                    :key="contentItem"
                    class="list-disc"
                >
                    <li class="rating-criteria-popup_content ml-4">
                        {{ contentItem }}
                    </li>
                </ul>
                <div v-else class="rating-criteria-popup_content">
                    {{ content[0] }}
                </div>
            </div>

            <div class="rating-criteria-popup_action" @click="close">
                <slot name="send">{{ $t("ok") }}</slot>
            </div>
        </div>
    </div>
</template>

<style scoped>
.rating-criteria-popup {
  @apply relative max-w-3xl max-h-[90%] md:max-h-screen overflow-auto bg-white border border-gray-50 rounded-2xl shadow-md p-4 md:p-6;
  width: 428px;
}
.rating-criteria-popup_container {
  @apply fixed flex items-center justify-center inset-0 bg-gray-600 bg-opacity-20 z-30 gap-4 px-4;
}
.rating-criteria-popup_container.hide {
  @apply hidden;
}
.rating-criteria-popup_title {
  @apply font-bold leading-5 text-gray-l-900;
  font-size: 22px;
}
.rating-criteria-popup_title_container {
  @apply flex flex-col gap-2 py-4;
}
.rating-criteria-popup_content {
  @apply font-normal text-fifteen-exploitation leading-5 text-gray-l-700;
}
.rating-criteria-popup_action {
  @apply flex justify-center w-full font-semibold text-fifteen-exploitation leading-4.5 border border-gray-l-800 rounded-lg py-2 cursor-pointer;
}
</style>
